import { Nullable } from 'common-types';

export enum AppFeature {
  PlaceHolder1 = 'place-holder-1',
}

export interface UserConfigurations {
  featureFlags: FeatureFlags;
}

export interface FeatureFlags {
  app: AppFeatureFlags;
}

export type AppFeatureFlags = {
  [index in AppFeature]: Nullable<boolean>;
} & {
  [AppFeature.PlaceHolder1]: Nullable<boolean>;
};
